// Pack de movimientos del avatar: punto de entrada.
//
//   const pack = createMotionPack(gltf.scene);       // una vez, con el modelo cargado
//   pack.motion.setBase('walk', { speed: 1.2 });     // base: 'idle' | 'walk'
//   pack.motion.play('wave');                        // capas encima: wave, talk_beat, talk_open, hand_chest, point,
//   pack.motion.play('talk_beat');                   //              shrug, nod_yes, shake_no  (se pueden combinar)
//   pack.motion.stop('talk_beat');
//   pack.motion.look(0.4, 0);                        // mirar a un punto
//   pack.motion.setFace('jaw', audioLevel);          // boca (0..1) desde el audio
//   useFrame((_, dt) => pack.update(dt));            // cada cuadro
import { Motion } from './blend.js';
import { bindRig } from './rig.js';

export { CLIPS } from './clips.js';
export { Motion } from './blend.js';
export { ROM, GAIT } from './anatomy.js';

export function createMotionPack(scene) {
  const rig = bindRig(scene);
  const motion = new Motion();
  return {
    motion,
    rig,
    /** Avanza la animación dt segundos y la aplica al esqueleto. Devuelve los canales aplicados. */
    update(dt) {
      const channels = motion.update(dt);
      rig.apply(channels);
      return channels;
    },
  };
}
